<template>
    <v-list-item dense link @click.native.stop="$emit('click')">
        <v-list-item-content class="py-0" style="max-width: 100px;">
            <v-list-item-title>
                {{ item.Id }}
            </v-list-item-title>
        </v-list-item-content>
        <v-list-item-content class="py-0">
            <v-list-item-title>
                {{ item.Name }}
            </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action class="my-0">
            <v-btn icon :disabled="!item.Latitude || !item.Longitude" @click.native.stop=""
                :href="'https://www.google.com/maps/search/?api=1&query=' + item.Latitude + '%2C' + item.Longitude"
                target="_blank">
                <v-icon>mdi-map-marker-radius</v-icon>
            </v-btn>
        </v-list-item-action>
    </v-list-item>
</template>


<script>
export default {
    name: 'DepartmentListItem',
    props: {
        item: Object,
    },
    components: {},

    data() {
        return {};
    },

    methods: {},

    computed: {},

    watch: {},
};
</script>


<style lang='scss' scoped></style>